/*@ngInject*/
const UserUtil = function (userType) {

    this.getTitleFromStateParam = function (paramUserType) {
        let agency = 'userList.manageAgencyUsersLabel',
            underwriter = 'userList.manageUnderwriters',
            service = 'userList.manageServiceUsers',
            system = 'userList.manageSystemUsers',
            result;

        switch (paramUserType) {
            case userType.UNDERWRITER:
                result = underwriter;
                break;
            case userType.AGENCY_BROKERAGE:
                result = agency;
                break;
            case userType.SYSTEM:
                result = system;
                break;
            case userType.SERVICE:
                result = service;
                break;
        }

        return result;
    };

    this.getOwnerUri = function (type, userId) {
        let agent = 'com.firstbest.underwriting.agent.Agent:',
            underwriter = 'com.firstbest.underwriting.underwriter.Underwriter:',
            system = 'com.firstbest.user.system.SystemUser:',
            service = 'com.firstbest.underwriting.serviceuser.ServiceUser:',
            result;

        type = parseInt(type);

        switch (type) {
            case userType.AGENCY_BROKERAGE:
                result = agent;
                break;

            case userType.SERVICE:
                result = service;
                break;

            case userType.SYSTEM:
                result = system;
                break;

            case userType.UNDERWRITER:
                result = underwriter;
                break;
        }

        return result + userId;
    };

    this.isValidNavigationItem = function (item) {
        return item.formTemplateAllowDirectNavigation && item.root;
    };
};

angular.module('umCore')
    .service('userUtil', UserUtil);
